import AssignmentChangeList from './AssignmentChangeList';

export default AssignmentChangeList;
